enum OperatorAlertEnum {
	BILLS = 'bills',
	COPARTICIPATION = 'coparticipation',
	INCOME_TAX = 'incomeTax',
	SAO_LUCAS_BILLS = 'saoLucasBills',
	SAO_LUCAS_COPARTICIPATION = 'saoLucasCoparticipation',
}

enum OperatorNameEnum {
	BIOHEALTH = 'biohealth',
	SAO_LUCAS_SAUDE = 'saoLucasSaude',
}

interface OperatorAlertProps {
	marginBottom?: string;
	variant: OperatorAlertEnum;
	operatorName?: OperatorNameEnum;
}

export type {OperatorAlertProps};
export {OperatorAlertEnum, OperatorNameEnum};
